const constants = {
  // STORAGE_TOKEN_KEY: 'token',
  // OAUTH_CLIENT_ID: 4,
  // OAUTH_GRANT_TYPE: 'password',
  // OAUTH_CLIENT_SECRET: 'UI96xJ7Ws2OLqIGxbmojZNcwaQYUtftPM0Qd1lDr',
  // OAUTH_SERVER_URL: 'https://apidesktop.enateinnova.com/oauth/token',
  // ROOT_URL: 'https://apidesktop.enateinnova.com'
  STORAGE_TOKEN_KEY: 'token',
  OAUTH_CLIENT_ID: 3,
  OAUTH_GRANT_TYPE: 'password',
  OAUTH_CLIENT_SECRET: 'KZqojManXkH2YxPEwyQ0qzfJ1VXPuK8Na8zVjMNb',
  OAUTH_SERVER_URL: 'https://apimobile.enateinnova.com/oauth/token',
  ROOT_URL: 'https://apimobile.enateinnova.com'
};
export default constants



// WEBPACK FOOTER //
// ./src/constants.js